import React from 'react';
import Box from '@mui/material/Box';
import { SxStyle } from '../../../types';
import RenderModuleFields from '../../common/fields/render-fields';
import { Field } from '../../../types';
import TeamPromosCategory from './categories/promos/team-promos';
import Theme from './categories/theme/theme';

const styles: SxStyle = {
  root: {
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingBottom: '24px',
  },
};

type CategoryPropTypes = {
  teamAbbrv: string;
  category: {
    name: string;
    fields: Field[];
    view?: JSX.Element;
  };
  isSuperAdmin: boolean | undefined;
  path: string;
  setChange: (
    key: string,
    value: string | number | boolean | null,
    validation: any,
    isTeamDataValue: boolean
  ) => void;
  setValidation: (key: string, value: string | number | boolean, validation: any) => void;
};

function Category(props: CategoryPropTypes) {
  const { category, isSuperAdmin } = props;

  if (category.name === 'Promos') {
    return <TeamPromosCategory {...props} />;
  } else if (category.name === 'Application Theme') {
    return <Theme {...props} />;
  } else {
    return (
      <>
        {category.fields
          .filter((field) => (isSuperAdmin && field.superAdminOnly) || !field.superAdminOnly)
          .map((field: any) => (
            <Box sx={styles.root} key={field.id}>
              <RenderModuleFields field={field} {...props} />
            </Box>
          ))}
      </>
    );
  }
}

export default Category;
